var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c(_vm.clickable ? 'button' : 'div',_vm._g({tag:"component",staticClass:"tag",class:{
    'tag--selected': _vm.clickable && _vm.isSelected,
    'tag--unselected': _vm.clickable && !_vm.isSelected
  },style:({ backgroundColor: _vm.color, color: _vm.textColor })},_vm.inputListeners),[_vm._v(_vm._s(_vm.label || _vm.$t('styleguide.label', 'Label')))])}
var staticRenderFns = []

export { render, staticRenderFns }